import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=7ad012ea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad012ea"]])

export default __exports__